import DecrementArrow from './DecrementArrow';

export default DecrementArrow;